import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CoreModule } from './core';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, CoreModule],
    providers: [CurrencyPipe]
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor() {}
}
